import { Avatar, Typography, Stack, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Iconify from './Iconify';
import palette from 'src/theme/palette';

export default function BackButton({ label = 'Back' }) {
  const navigate = useNavigate();

  return (
    <Stack direction="row" alignItems="center" spacing={1} mb={2} ml={0}>
      <IconButton onClick={() => navigate(-1)} sx={{ padding: 0 }}>
        <Avatar
          sx={{
            backgroundColor: (theme) => theme.palette.primary.main,
            width: 32,
            height: 32
          }}
        >
          <Iconify icon={'ion:chevron-back-outline'} sx={{ fontSize: 15, color: '#fff' }} />
        </Avatar>
      </IconButton>
      <Typography
        sx={{
          fontSize: 14,
          color: palette.primary.titledark,
          fontFamily: 'poppinsMedium'
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
}
